import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMastercard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={410}
    height={260}
    viewBox="0 0 41 26"
    {...props}
  >
    <g fill="none" fillRule="nonzero">
      <path fill="#F16022" d="M14.856 3.205H25.83v19.72H14.856z" />
      <path
        fill="#E91D25"
        d="M15.552 13.066c0-4.001 1.874-7.564 4.79-9.86a12.5 12.5 0 0 0-7.75-2.682C5.666.524.052 6.14.052 13.066s5.614 12.541 12.54 12.541c2.926 0 5.617-1.002 7.75-2.681a12.52 12.52 0 0 1-4.79-9.86"
      />
      <path
        fill="#F69E1E"
        d="M40.634 13.066c0 6.926-5.615 12.541-12.54 12.541a12.5 12.5 0 0 1-7.751-2.681 12.52 12.52 0 0 0 4.79-9.86c0-4.001-1.873-7.564-4.79-9.86a12.5 12.5 0 0 1 7.75-2.682c6.926 0 12.54 5.615 12.54 12.542m-1.197 7.771v-.404h.163v-.082h-.415v.082h.163v.404zm.805 0v-.487h-.127l-.146.335-.146-.335h-.127v.487h.09v-.367l.136.316h.093l.137-.317v.368z"
      />
    </g>
  </svg>
);
export default SvgMastercard;
